import {atcStates} from '../atc-routes';
export default function AtcFlightsHeaderBaseController(
    $scope,
    $state,
    atcFlightsFactory,
    userService,
    l10nService,
    atcFlightsUtils,
    atcTimeService,
) {
    'ngInject';

    $scope.module = atcFlightsFactory.getModule();
    $scope.labels = atcFlightsFactory.getLabels();
    $scope.options = atcFlightsFactory.options;
    $scope.params = atcFlightsFactory.params;
    $scope.tempParams = angular.copy(atcFlightsFactory.params);
    $scope.isCurrentDay = atcFlightsFactory.isCurrentDay;
    $scope.workingHoursRestriction = userService.getUser().WorkingHoursRestriction;

    // Format departure and return date
    const convertedDepartureDate = atcTimeService.parseAtcApiFormat(
        $scope.params.TicketSearchSegments[0].DepartureDate
    );
    const totalSegment = $scope.params.TicketSearchSegments.length;
    const convertedReturnDate = atcTimeService.parseAtcApiFormat(
        $scope.params.TicketSearchSegments[totalSegment - 1].DepartureDate);

    $scope.headerAll = {
        Total: $scope.flights.Total,
        FilteredTotal: $scope.flights.FilteredTotal,
        TotalPassengerCount: +$scope.params.Travellers.Adult.value + +$scope.params.Travellers.Infant.value + +$scope.params.Travellers.Child.value,
        convertedDepartureDate,
        convertedReturnDate,
        route: atcFlightsUtils.calculateRoute($scope.conditions),
        dates: atcFlightsUtils.calculateDates($scope.conditions),
    };

    const initialDepartDate = atcTimeService.parseAtcApiFormat(
        $scope.params.TicketSearchSegments[0].DepartureDate);

    const initialReturnDate = atcTimeService.parseAtcApiFormat(
        $scope.params.TicketSearchSegments[totalSegment - 1].DepartureDate);

    $scope.dateOptions = {
        optionsDepart: {
            placeholder: l10nService.localize('Depart date'),
            required: true,
            months: 2,
            start: initialDepartDate,
            after: moment().add({days: -1}),
            before: atcFlightsFactory.getMaxBookDate(),
            dependentPikers: ['dateOptions.optionsReturn'],
        },
        optionsReturn: {
            placeholder: l10nService.localize('Return date'),
            required: true,
            months: 2,
            start: initialReturnDate,
            before: atcFlightsFactory.getMaxBookDate(),
            after: moment(initialDepartDate).add({days: -1}),
        },
    };

    // Header is collapsed initially
    $scope.state = {
        showHeader: true,
    };

    $scope.$watch('state.showHeader', function(newValue) {
        if (newValue) {
            $scope.tempParams = angular.copy($scope.params);
            $scope.dateOptions.optionsReturn.after = moment(initialDepartDate).add({days: -1});
        }
    });

    $scope.edit = edit;
    $scope.findFlights = findFlights;
    $scope.swapLocationsInAllSegments = swapLocationsInAllSegments;

    function findFlights() {
        atcFlightsFactory.findFlights($scope.tempParams)
            .then(() => $state.go($state.current, {}, {reload: true, inherit: false, notify: true}));
    }

    function edit() {
        $state.go(atcStates.CHECK_RESULT, {
            pnr: $scope.params.Pnr,
            trip: $scope.params.TripId,
            department: $scope.params.DepartmentId,
            fromTripDetails: $scope.params.FromTripDetails,
        });
    }

    function swapLocationsInAllSegments() {
        $scope.tempParams.TicketSearchSegments = $scope.tempParams.TicketSearchSegments
            .map((segment) => ({
                ...segment,
                _arrival: segment.departureAirport,
                _departure: segment.arrivalAirport,
            }));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsHeaderBaseController.js